<template>
  <section
    :class="{
      'portable-text-custom-table': true,
    }"
  >
    <Padding :padding>
      <CustomTable
        v-if="customTable"
        v-bind="customTable"
        :mobile-responsive
        :border
        :striped-rows
      />
    </Padding>
  </section>
</template>

<script lang="ts" setup>
import Padding from '~/components/Atmos/Padding/Padding.vue';
import CustomTable from './CustomTable.vue';
import type { PortableTextCustomTable } from '~/sanity/types';
defineProps<PortableTextCustomTable>();
</script>

<style></style>
